import React from 'react';
import { Stack } from '@mui/material';
import { t } from 'i18next';
import POSHeading from '@/components/POS/Common/POSHeading';
import OnlinePaymentsList from './UI/List/OnlinePaymentsList';

export default function OnlinePaymentsLayout() {
    return (
        <Stack>
            <POSHeading sx={{ my: 2 }} text={t('POS.OnlinePaymentsHeader')} />
            <OnlinePaymentsList />
        </Stack>
    );
}
